import {customElement, bindable, autoinject, containerless } from "aurelia-framework";
import {EditableInputElementService, IEditableInlineEditor, ISelectOption} from "../editable-input-element-service";
import {IDisposable} from "../../../interfaces/IDisposable";
import "./editable-inline-select.css";

/**
 * This custom element wraps and controls the dropdown that is used for editing a field when the
 * editable-inline attribute is applied to a select element.  It can be used across multiple input elements.
 */
@containerless
@autoinject
@customElement('editable-inline-select')
export class EditableInlineSelect implements IEditableInlineEditor {
    constructor(
        private editableInputElementService: EditableInputElementService
    ) {
    }

    @bindable classEx: string|null = null;

    private select: Element;
    private _value: any;

    private items: Array<ISelectOption>;

    private text: string;
    private dropdown: JQuery;
    private onSave: () => void;
    private isShowing: boolean = false;

    public set value(value: any) {

        let selectedOption = this.items.find((option) => { return option.value === value; } );

        if (selectedOption != null) {
            this.text = selectedOption.text;
            this._value = value;
        } else {
            this.text = "[option with value not found]";
            this._value = "";
        }
    }

    public get value(): any {
        return this._value;
    }

    bind() {
        this.editableInputElementService.editor = $(this.select);
        this.dropdown = this.editableInputElementService.editor.find("span");

        let select = $(this.select).find(".dropdown");

        select.on("hidden.bs.dropdown", () => {
            this.hide();
        });

        if (this.classEx) {
            select.addClass(this.classEx);
        }
    }

    /**
     * 
     * @param element
     * @param onKeyPress called on any keypress
     * @param onSave -- called on blur
     */
    public show(element: JQuery, data: Array<ISelectOption>, currentValue: any, onKeyPress: (event: Event) => boolean, onSave: () => void): void {

        if (!this.isShowing) {

            let select = $(this.select);

            this.editableInputElementService._show(element);

            let ul = select.find("ul");

            let items = this.items = data;

            ul.empty();

            for (let item of items) {
                let li = $('<li></li>');

                li.append($("<a/>")
                    .attr('href', "#")
                    .text(item.text)
                    .click(() => {
                        this.itemSelected(item);
                        return false;
                    })
                );

                ul.append(li);
            }

            (<any>$(window)).on("keydown.editable-inline-select", onKeyPress);

            //select.on("shown.bs.dropdown", () => {
            //    this.isShowing = true;
            //});

            this.value = currentValue;

            this.onSave = onSave;

            setTimeout(() => {
                    if (!this.isShowing) {
                        this.dropdown.dropdown("toggle");
                        this.isShowing = true;
                    }
                },
                10);
        }
    }

    private itemSelected(item: ISelectOption) {
        this.value = item.value;

        //setTimeout(() => { this.dropdown.dropdown("toggle"); this.onSave(); }, 10);
        //this.dropdown.dropdown("toggle");
        this.onSave(); 
    }

    public hide(): void {

        if (this.isShowing) {
            this.editableInputElementService._hide();

            $(window).off("keydown.editable-inline-select");

            this.dropdown.off("shown.bs.dropdown");
            this.dropdown.off("hidden.bs.dropdown");

            this.dropdown.dropdown("toggle");

            this.isShowing = false;
        }
    }

    public get maxLength(): number {
        return this.editableInputElementService.maxLength;
    }

    detached() {
        this.editableInputElementService.detached();
    }

    attached() {
        this.editableInputElementService.attached();
    }

    public static dropdownTextFromValue(dropdownData: Array<ISelectOption>, value: number | string): string {
        let selectItem = dropdownData.find((dd) => { return dd.value === value });
        return selectItem ? selectItem.text : "";
    }
}

//interface IInlineSelectParams {
//    items: () => Array<ISelectOption>;
//    initialText: string;
//}

// export type FnGetItems = Array<ISelectOption>;